module.exports = __webpack_public_path__ + "assets/images/project/head/Nor_Diana.jpg?v=a12ef083";